import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { variant01 } from "../motion/variants";

const SplashScreen = () => {
  const texts = ["NASA", "APOLLO 11", "Man", "on the", "Moon"];
  const [selectedTxt, setSelectedTxt] = useState(0);

  useEffect(() => {
    let i = 0;
    let interval;
    setTimeout(() => {
      interval = setInterval(() => {
        if (i <= texts.length) {
          i++;
          setSelectedTxt(i);
        } else {
          clearInterval(interval);
        }
      }, 250);
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  return (
    <motion.div
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.75 }}
      id="splashscreen"
    >
      <motion.header
        initial="hidden"
        animate="visible"
        variants={variant01}
        transition={{ delay: 0.4 }}
      >
        <span>Spector Books</span>
        <span>Discovered</span>
      </motion.header>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.2, delay: 1 }}
        className="title"
      >
        {selectedTxt < texts.length ? (
          <h1>{texts[selectedTxt]}</h1>
        ) : (
          texts.map((elem) => <h1 key={elem}>{elem}</h1>)
        )}
      </motion.div>

      <motion.footer
        initial="hidden"
        animate="visible"
        variants={variant01}
        transition={{ delay: 0.6 }}
      >
        <span>Steffen Knöll (ed.)</span>
      </motion.footer>
    </motion.div>
  );
};

export default SplashScreen;
